import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DateService } from '@app/@shared/services/date.service';

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss'],
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
  @Input() endTime!: Date;
  @Input({ required: true }) dateS!: DateService;
  private interval: any;
  timeLeft = 0;

  hours = 0;
  minutes = 0;
  seconds = 0;

  constructor() {}

  ngOnInit(): void {
    this.calculateTimeLeft();
    this.interval = setInterval(() => this.calculateTimeLeft(), 1000);
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  private async calculateTimeLeft(): Promise<void> {
    const now = (await this.dateS.dateNow()).getTime();
    this.timeLeft = new Date(this.endTime).getTime() - now;

    if (this.timeLeft > 0) {
      this.hours = Math.floor((this.timeLeft / (1000 * 60 * 60)) % 24);
      this.minutes = Math.floor((this.timeLeft / (1000 * 60)) % 60);
      this.seconds = Math.floor((this.timeLeft / 1000) % 60);
    } else {
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
    }
  }
}
